import { render, staticRenderFns } from "./PortalUserDetails.vue?vue&type=template&id=df152cd6"
import script from "./PortalUserDetails.vue?vue&type=script&lang=ts"
export * from "./PortalUserDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports